import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.XeroAmaxPayBatchPaymentPaymentStep', {
    addPayer: 'Add a Payer',
    bubbleText: 'Send payment',
    payerTag: 'Can send payment with any bank account',
    stepDescription: 'Payers can authorize the approved payments for processing.',
});
